/**
 * @param {string} breakpoint the breakpoint you want to convert
 */
export function breakpoint(breakpoint: string) {
  return Number(breakpoint.slice(0, -2));
}
